import React, { useEffect, useState, useRef } from 'react';
import { Button, Tooltip, Row, Col, Modal, Input, Switch, Space, Collapse, Alert, notification, ColorPicker, Card, Select, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { useLocation } from 'react-router-dom';
import { retLastSegmentURL } from '../utils/retLastSegmentURL';
import { RootState } from '../redux/store';
import moment from 'jalali-moment';
import { useGetQuery } from '../frameWork/rest';
import { API_ENDPOINTS } from '../frameWork/utils/keyapi-endpoints';

interface mytype { modalOpen: boolean, setDialogOpen: any }

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ShareDashInfoPageDialog = ({ modalOpen, setDialogOpen }: mytype) => {
  const query = useQuery();
  const data: any = query.get('data');
  const [shareingExpireValue, setShareingExpireValue] = useState('');
  const [message, setMessage] = useState('');
  const [enc, setEnc] = useState('');
  const [copyCode, setCopyCode] = useState("");

  const { locationId } = useSelector((state: any) => state.DashboardPage, _.isEqual);
  const { userDetails } = useSelector((state: RootState) => ({
    userDetails: state.Auth.userDetails
  }));
  let s_Param = `${locationId}?data=${data}`

  const { isLoading: isloading, data: sharePageInfo, refetch: getSharePageInfo } = useGetQuery(API_ENDPOINTS.PUBLIC_PAGEINFO, "", s_Param);

  useEffect(() => {    
    const d = async () => {
      getSharePageInfo()
    }
    d()
  }, [])

  const CloseHandlingModal = () => {
    setDialogOpen();
  }

  return (
    <Modal
      width={550}
      style={{ position: 'relative', height: 'calc(100vh - 300px)' }}
      styles={{ body: { overflowY: 'scroll', height: 150 } }}
      zIndex={1050}
      maskClosable={false}
      destroyOnClose
      open={modalOpen}
      afterClose={CloseHandlingModal}
      title="اطلاعات لینک صفحه انتشار شده"
      onCancel={setDialogOpen}
      okText="ذخیره"
      cancelText="انصراف"
      footer={
        [
          <Button key="back" onClick={CloseHandlingModal}>
            انصراف
          </Button>,
        ]
      }
    >
      {isloading ? <Spin /> :
        <>
          <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: 10 }}>
            <span style={{ color: 'rgb(113, 113, 113)', marginLeft: 10 }}>نام صفحه :</span>
            <span>{sharePageInfo?.pageName}</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: 10 }}>
            <span style={{ color: 'rgb(113, 113, 113)', marginLeft: 10 }}>ایجاد کننده :</span>
            <span>{sharePageInfo?.userName}</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: 10 }}>
            <span style={{ color: 'rgb(113, 113, 113)', marginLeft: 10 }}>تاریخ ایجاد :</span>
            <span>{sharePageInfo?.createDate}</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: 10 }}>
            <span style={{ color: 'rgb(113, 113, 113)', marginLeft: 10 }}>تاریخ انقضاء :</span>
            <span>{sharePageInfo?.expireDate}</span>
          </div>
        </>
      }
    </Modal >
  );
};

export default ShareDashInfoPageDialog;
